import { render, staticRenderFns } from "./GameName.vue?vue&type=template&id=f3723cc0&scoped=true"
import script from "./GameName.vue?vue&type=script&lang=js"
export * from "./GameName.vue?vue&type=script&lang=js"
import style0 from "./GameName.vue?vue&type=style&index=0&id=f3723cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3723cc0",
  null
  
)

export default component.exports